<template>
  <div class="system">
    <h2>发布系统消息</h2>
    <div class="normal">发给谁：
      <el-select v-model="range" placeholder="请选择" multiple filterable allow-create>
        <el-option v-for="item in rangeList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="inputBox normal">
      <el-input type="textarea" v-model="words" cols="40" rows="5" resize="none" style="font-size: 20px;"></el-input>
    </div>
    <div class="normal">
      <input type="file" @change="chooseImage">
    </div>
    <div class="inputBox">
      <div class="imageBox">
        <div v-for="(url,index) in images" :key="index" class="imageItem">
          <img :src="url.replace('_mini.jpg', '')" preview="8">
          <button @click="delImage(index)">删除</button>
        </div>
      </div>
    </div>
    <div class="normal">
      <el-button type="primary" @click="upToDb">发送</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: '',
        words: '',
        range: [],
        images: [],
        rangeList: [{
          label: '置业顾问',
          value: '置业顾问'
        }, {
          label: '经纪人',
          value: '经纪人'
        }, {
          label: '普通用户',
          value: '普通用户'
        }],

        systemMap: {
          '杭州': 'WpSystemModel',
          '苏州': 'SzSystemModel',
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {

      init() {
        let that = this;
        let obj = that.$route.params;
        console.log('obj', obj);
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: that.systemMap[that.$store.state.Counter.city]
            }
          }).then(res => {
            console.log('back', res);
            let message = res.data.data;
            that.id = message.id;
            that.words = message.words;
            that.range = message.range;
            that.images = message.images;
          }).catch(err => {
            console.log('err', err);
          })
        } else if (obj.user_id && obj.user_name) {
          that.range.push(obj.user_id);
          that.rangeList.push({
            label: obj.user_name,
            value: obj.user_id
          })
        }
      },

      //选择图片
      chooseImage(event) {
        let that = this;
        let option = {
          file: event.target.files[0],
          head_name: 'system_message',
        };
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res);
          if (!res) {
            console.log('upload fail')
            return;
          }
          that.images.push(res);
          that.$previewRefresh();
        }).catch(function (res) {
          console.log('upload fail', res);
        })
      },

      //上传数据库
      upToDb() {
        let that = this;
        if (!that.words) {
          that.$message.error('消息内容必填');
          return;
        }
        if (that.range.length === 0) {
          that.$message.error('未指定发给谁');
          return;
        }
        
        let obj = {
          words: that.words,
          images: that.images,
          range: that.range
        };
        if (that.id) {
          obj.id = that.id;
        }
        let param = {
          'db': that.systemMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      delImage(index) {
        this.images.splice(index, 1);
      }

    }
  }

</script>

<style scoped>
  .system {
    text-align: center;
    overflow: hidden;
  }

  h2 {
    margin-top: 50px;
  }

  .adImg {
    height: 100px;
  }

  .inputBox {
    display: inline-block;
  }

  .imageBox {
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

</style>



// WEBPACK FOOTER //
// src/page/System.vue